import { Trans } from 'react-i18next';

import { dateTimeMinuteFormatter, Translate } from '@dreryk/react-common';

import { translationKeys } from '../translations';
import { isAutomaticRefundValid } from '../shared/automaticRefund';

import { StyledAdvancePaymentRefundAmountConditionText } from './AdvancePaymentRefundAmountConditionText.styled';

type AdvancePaymentRefundAmountConditionProps = Readonly<{ refundExpirationDate: Date | null | undefined }>;

export const AdvancePaymentRefundAmountCondition = (props: AdvancePaymentRefundAmountConditionProps): JSX.Element => {
   return (
      <StyledAdvancePaymentRefundAmountConditionText testId={'advancePaymentRefundAmountCondition'}>
         {isAutomaticRefundValid(props.refundExpirationDate) ? (
            <Trans
               i18nKey={translationKeys.automaticRefundsPossibleTo}
               values={{ date: dateTimeMinuteFormatter(props.refundExpirationDate) }}
            />
         ) : (
            <Translate>{translationKeys.visitCancelledTooLate}</Translate>
         )}
      </StyledAdvancePaymentRefundAmountConditionText>
   );
};
